import { createFileRoute } from '@tanstack/react-router';

// 顧客詳細 > 利用機能の編集画面。
// URL search は持たない（候補ダイアログ内検索はローカル state で完結）ため
// ここではルート定義のみ。コンポーネントは index.lazy.tsx で遅延ロードする。
// 利用機能タブ自体は _layout/index に居るため target-nodes/ に index は作らない。
export const Route = createFileRoute('/_stacktrace/customers/$customerId/_layout/target-nodes/edit/')({});